module.exports = __webpack_public_path__ + "img/down-xl1.d6084f43.png";